import React from 'react'
import moment from 'moment'
import DatosCodigoDeCupo from './DatosCodigoDeCupo'
import DatosHistoriaCpaPorCodigo from './DatosHistoriaCpaPorCodigo'

function DetalleCodigoDeCupoView (props) {
  const { codigoDeCupo, cpaPorCodigo } = props
  moment.locale('ar-AR')

  const codigo = [
    {
      titulo: 'Código de cupo',
      valor: codigoDeCupo.codigoCupo
    },
    {
      titulo: 'Fecha de cupo',
      valor: codigoDeCupo.fechaDeCupo
    },
    {
      titulo: 'Cereal',
      valor: codigoDeCupo.cereal
    },
    {
      titulo: 'Tipo de cupo',
      valor: codigoDeCupo.tipoCupo === 'N' ? 'Nominado' : 'Libre'
    },
    {
      titulo: 'Exportador',
      valor: codigoDeCupo.exportador
    },
    {
      titulo: 'Titular de cupo',
      valor: codigoDeCupo.tipoCupo === 'N' ? codigoDeCupo.cargador : null
    },
    {
      titulo: 'Corredor de cupo',
      valor: codigoDeCupo.tipoCupo === 'N' ? codigoDeCupo.corredor : null
    },
    {
      titulo: 'Estado en StopQ',
      valor: codigoDeCupo.stopq
    },
    {
      titulo: 'Estado CTG',
      valor: codigoDeCupo.estadoCupoStopq ? codigoDeCupo.estadoCupoStopq : 'Sin consumir'
    },
    {
      titulo: 'Arribo',
      valor: codigoDeCupo.arribo
    }
  ]

  return (
    <>
      <DatosCodigoDeCupo codigo={codigo} />
      <br />
      { (cpaPorCodigo.length > 0) && <DatosHistoriaCpaPorCodigo
        cpaPorCodigo={cpaPorCodigo}
      />
      }
    </>
  )
}

export default DetalleCodigoDeCupoView
